export const backendPoint = process.env.REACT_APP_GRAPHQL_ENDPOINT;
export const editorUrl = process.env.REACT_APP_EDITOR_URL;
export const viewerUrl = process.env.REACT_APP_VIEWER_URL;
export const appUrl = process.env.REACT_APP_URL;
export const userpoolId = process.env.REACT_APP_USER_POOL_ID;
export const userpoolClientId = process.env.REACT_APP_USER_POOL_CLIENT_ID;
export const cognitoRegionName = process.env.REACT_APP_COGNITO_REGION_NAME;
export const appDomain = process.env.REACT_APP_APP_DOMAIN;
export const addToClassStatusId =
  process.env.REACT_APP_DYNO_STATUS_ADDTOCLASS_ID;
